import { connect } from 'react-redux'
import Select from '../Components/JustSelect'
import { mapStateToProps, mapDispatchToProps } from '../Utils/mapToProps'

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Select)
